async function Delete(designcomponentid) {

    if (designcomponentid.length > 0) {

        let response;

        response = await fetch("https://api.cssi.co/CNF/DeleteDesignComponent", {
            method: "POST",
            body: JSON.stringify(
                {
                    "designComponentId": designcomponentid
                }
            )
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })
        return Promise.resolve(response);
    }
}

export default Delete;